import React from "react";
import SEO from "../Componentes/seo";

const Error = () => {
    return (
        <>
            <SEO
                title="Página no encontrada"
                description="La página solicitada no existe en JCMR Portafolio."
                path="/404"
                noIndex={true}
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    name: "Página no encontrada | JCMR Portafolio",
                    url: "https://portafoliojcmr.netlify.app/404",
                    description: "Página de error 404 del portafolio de Juan Camilo Muñoz."
                }}
            />
            <h1>Error 404, EFE</h1>
        </>
    );
}    

export default Error;
